// @flow
import { acquisitionsSupportUsRecurringContribution } from 'common/modules/experiments/tests/acquisitions-support-us-recurring-contributions';

export const membershipEngagementBannerTests: $ReadOnlyArray<
    AcquisitionsABTest
> = [acquisitionsSupportUsRecurringContribution];



// WEBPACK FOOTER //
// ./static/src/javascripts/projects/common/modules/experiments/tests/membership-engagement-banner-tests.js